import { accountTypes } from '../util/enum/api/accountTypes';

export function buildSfhIrsDrawerCopy({
  t,
  accountType,
  individualDisplayName,
  learnMoreHref,
}) {
  const isJoint =
    accountType === accountTypes.JointTenantsInCommon ||
    accountType === accountTypes.JointTenantsWithRightOfSurvivorship;
  const isTrust = accountType === accountTypes.Trust;
  const isIndividual = accountType === accountTypes.Individual;

  return {
    title: t('common.irsReportingRequired'),
    learnMoreHref,
    learnMoreText: t('irs.learnMore'),
    secureFootnote: t('irs.footNote'),
    inputLabel: isTrust ? t('common.tinFieldTitle') : t('common.ssnFieldTitle'),
    inputPlaceholder: isTrust
      ? t('sellWizard.sfhWizard.irsDrawer.placeholderTin')
      : t('sellWizard.sfhWizard.irsDrawer.placeholderSsn'),
    isTrust,
    isJoint,
    isIndividual,
    individualDisplayName,
  };
}
